export const keys = {
  end: 35,
  home: 36,
  left: 37,
  right: 39,
  enter: 13,
  space: 32,
};

// Add or subtract depending on key pressed
export const directions = {
  37: -1,
  39: 1,
};
